<template>
  <b-table
    class="sticky-table-header"
    :data="orders"
    hoverable
    narrowed
    @click="openOrderDetails"
    style="cursor: pointer"
  >
    <b-table-column
      field="createdAt"
      :label="$t('common.date')"
      v-slot="props"
      centered
    >
      <p class="adjusted-top">
        {{
          new Date(props.row.createdAt).toLocaleDateString(
            undefined,
            orderDateFormat
          )
        }}
      </p>
    </b-table-column>

    <!-- <b-table-column
      field="store.storeInfo.name"
      :label="$t('common.store')"
      v-slot="props"
      centered
    >
      {{ props.row.store.storeInfo.name }}
    </b-table-column> -->

    <b-table-column
      field="orderId"
      :label="$t('orders.orderId')"
      v-slot="props"
      centered
    >
      <p class="adjusted-top">
        {{ props.row.orderId }}
      </p>
    </b-table-column>

    <b-table-column
      field="details.chargedValue"
      :label="$t('common.value')"
      v-slot="props"
      centered
    >
      <b-dropdown
        :triggers="['hover']"
        aria-role="list"
        position="is-bottom-left"
      >
        <template #trigger>
          <button class="button is-light" slot="trigger" @click.stop>
            {{
              `${payments.currencySymbol} ${formatMoney(
                props.row.details.chargedValue
              )}`
            }}
          </button>
        </template>

        <b-dropdown-item
          aria-role="listitem"
          v-for="item in props.row.cart.items"
          :key="item._id"
        >
          <p>
            {{
              item.scaleProduct && item.unit === "un"
                ? `${item.quantity} x ${payments.currencySymbol}${formatMoney(
                    item.price
                  )} - ${item.name}`
                : item.scaleProduct
                ? `1 x ${payments.currencySymbol}${formatMoney(
                    item.itemPrice
                  )} - ${item.name} ${item.quantity}g`
                : `${item.quantity} x ${payments.currencySymbol}${formatMoney(
                    item.price
                  )} - ${item.name}`
            }}
          </p>
        </b-dropdown-item>
      </b-dropdown>
    </b-table-column>

    <b-table-column
      field="details.status"
      :label="$t('common.status')"
      v-slot="props"
      centered
    >
      <b-button
        :type="{
          'is-success': props.row.details.status === 'success',
          'is-light': props.row.details.status === 'cancelled',
          'is-dark': props.row.details.status === 'refunded',
          'is-danger': props.row.details.status === 'chargeback',
          'is-sea': props.row.details.status === 'pending'
        }"
        :disabled="props.row.details.status === 'cancelled'"
        slot="trigger"
        style="cursor: default"
      >
        {{
          props.row.details.status === "success"
            ? $t("orders.statusSuccess")
            : props.row.details.status === "cancelled"
            ? $t("orders.statusCancelled")
            : props.row.details.status === "pending"
            ? $t("orders.statusPending")
            : order.details.status === "refundedRequested"
            ? $t("orders.statusRefundRequested")
            : order.details.status === "refunded"
            ? $t("orders.statusRefunded")
            : order.details.status === "refundRefused"
            ? $t("orders.statusRefundRefused")
            : order.details.status === "refundFailed"
            ? $t("orders.statusRefundFailed")
            : order.details.status === "refundReversed"
            ? $t("orders.statusRefundReversed")
            : props.row.details.status === "chargeback"
            ? $t("orders.statusChargeback")
            : "-"
        }}
      </b-button>
    </b-table-column>

    <b-table-column
      field="paymentLink"
      :label="$t('orders.paymentLink')"
      v-slot="props"
      centered
    >
      <b-button @click.stop="copyPaymentLink(props.row.paymentLink)">
        <b-icon icon="copy"></b-icon>
      </b-button>

      <p v-show="false" id="paymentlink"></p>
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";

export default {
  props: ["orders"],

  mixins: [mask],

  components: {
    tableEmptyTemplate
  },

  data() {
    return {
      orderDateFormat: {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
    };
  },

  methods: {
    copyPaymentLink(paymentLink) {
      const doc = document;

      doc.querySelector(`#paymentlink`).innerHTML = paymentLink;
      const clone = doc.querySelector(`#paymentlink`).cloneNode(true);
      clone.style = "position: absolute; left: -1000px; top: -1000px";
      clone.id = "clone";
      clone.innerHTML = paymentLink;
      doc.body.appendChild(clone);

      const text = doc.querySelector(`#clone`);
      let range;
      let selection;

      if (doc.body.createTextRange) {
        range = doc.body.createTextRange();
        range.moveToElement(text);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = doc.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      try {
        if (document.execCommand("copy")) {
          this.$buefy.toast.open({
            message: this.$t("orders.linkCopied"),
            type: "is-primary"
          });
        } else {
          this.alertError({ message: "COPY_FAILED" });
        }
      } catch (err) {
        this.alertError({ message: "COPY_FAILED" });
      }

      window.getSelection().removeAllRanges();
      doc.body.removeChild(clone);
    },

    openOrderDetails(order) {
      this.$emit("open-order-details", order._id);
    }
  },

  computed: {
    ...mapGetters(["payments"])
  }
};
</script>

<style scoped>
.adjusted-top {
  position: relative;
  top: 7px;
}
</style>
